<div class="input-group sg-input-group d-flex flex-nowrap"
    [class.sg-input-group__secondary]="inputStyle == 'secondary'"
    [class.sg-input-group__error]="errors.length > 0"
    [class.sg-input-group__focus]="focused">
    <div class="input-group-prepend sg-input-group__prepend sg-rounded-left" *ngIf="icon">
        <div class="sg-input-group__prepend__icon h-100 sg-rounded-left d-flex align-items-center justify-content-center">
            <mlp-ng-icon class="mw-100" name="{{icon}}"></mlp-ng-icon>
        </div>
        <div class="sg-input-group__prepend__divider d-flex align-items-center">
            <div class="sg-input-group__prepend__divider__line"></div>
        </div>
    </div>

    <mlp-ng-input-atom
        class="flex-fill"
        [inputType]="inputType"
        [noBorder]="true"
        [placeholder]="placeholder"
        [inputId]="inputId"
        [inputName]="inputName"
        [inputDisabled]="inputDisabled"
        [(ngModel)]="value"
        (focus)="focused = true; focus.emit($event)"
        (blur)="focused = false; blur.emit($event)"
    ></mlp-ng-input-atom>

    <div class="input-group-append sg-input-group-append sg-rounded-right">
        <div class="sg-rounded-right">
            <button
                type="button"
                class="btn sg-btn h-100 sg-input-group-append-button-icon"
                [ngbTooltip]="tooltipTemplate || tooltip"
                [placement]="placement"
                [tooltipClass]="tooltipClass"
            >
                <mlp-ng-icon class="mw-100" name="{{iconTooltip}}"></mlp-ng-icon>
            </button>
        </div>
    </div>
</div>

<small class="form-text sg-color__danger" *ngFor="let error of errors">{{ error.title }}</small>